import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  //apiBaseUrl: 'http://localhost:8080', // Dev Node.js endpoint (requires local PostgreSQL on port 5433)
  apiBaseUrl: 'https://openpyq-dev-nodejs-44451026832.us-central1.run.app',
  imageToolApiUrl: 'http://localhost:8082', // Image Processing Tool API
  googleClientId: '44451026832-5l54vs1n69cuml7hmpagvopvf1dveuo8.apps.googleusercontent.com', // Correct OpenPYQ Google Client ID
  ga4MeasurementId: 'G-BDHY61T299' // Replace with your actual GA4 Measurement ID
};
